import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSortModule, Sort } from "@angular/material/sort";
import { Router, RouterModule } from "@angular/router";
import { Chat, ChatType } from "src/app/classes/chat";
import { User } from "src/app/classes/user";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ChatService } from "src/app/services/chat.service";
import { UserProfileImageService } from "src/app/services/user-profile-image.service";
import { take } from "rxjs/operators";


@Component( {
	selector: "chat-search-contact",
	templateUrl: "chat-search-contact.component.html",
	styleUrl: "chat-search-contact.component.scss",
	standalone: true,
	imports: [
		FormsModule,
		MatButtonModule,
		MatIconModule, 
		MatProgressBarModule, MatProgressSpinnerModule, 
		RouterModule,
		MatSortModule,
	]
} )
export class ChatSearchContactComponent implements OnInit {


	bFirstLoading = true;
	bFirstLoadingError = false;
	bCreatingChat = false;

	myUserId = "";

	contacts: User[] = [];
	contactsFiltered: User[] = [];
	contactNames: { [key:string]: string } = {};
	contactAvatarUrls: Record<string, string | null> = {};
	readonly defaultAvatar = "assets/user.png";

	strContactFilter = "";

	bSavingError = false;


	constructor(
		private chatService: ChatService,
		private router: Router,
		private authenticationService: AuthenticationService,
		private userProfileImageService: UserProfileImageService
	) {}


	ngOnInit() {

		this.myUserId = this.authenticationService.getCurrentUser().ebeId;

		this.chatService.getContacts().subscribe( contacts => {

			this.bFirstLoading = false;
			if( !contacts ) return;

			this.contacts = contacts
				.filter( c => c.ebeId != this.myUserId )
				.sort( (a,b) => {
					const arrA: string[] = [];
					if( a.ebeVorname ) arrA.push( a.ebeVorname );
					if( a.ebeName ) arrA.push( a.ebeName );
					if( arrA.length ) arrA.push( a.ebeId );
					const nameA = arrA.join( " " );
					const arrB: string[] = [];
					if( b.ebeVorname ) arrB.push( b.ebeVorname );
					if( b.ebeName ) arrB.push( b.ebeName );
					if( arrB.length ) arrB.push( b.ebeId );
					const nameB = arrB.join( " " );

					return nameA.localeCompare( nameB );
				} );
			this.contactsFiltered = this.contacts;

			for( const contact of this.contacts ) {
				const arr: string[] = [];
				if( contact.ebeVorname ) arr.push( contact.ebeVorname );
				if( contact.ebeName ) arr.push( contact.ebeName );
				if( !arr.length ) arr.push( contact.ebeId );
				this.contactNames[ contact.ebeId ] = arr.join( " " );
			}

			this.loadContactAvatars(this.contacts.map(c => c.ebeId));

		});

	}


	contactFilter( event: Event ) {

		if( !this.strContactFilter ) {
			this.contactsFiltered = this.contacts;
			return;
		}

		const filter = this.strContactFilter.toLocaleLowerCase();
		this.contactsFiltered = this.contacts.filter( c => {
			const name = (c.ebeVorname + " " + c.ebeName).toLocaleLowerCase();
			return( name.includes(filter) );
		});

		this.sortList( "asc", "contactName" );

	}

	clickContact( userId: string ) {

		if( this.bCreatingChat ) return;
	
		this.bCreatingChat = true;

		const chat = new Chat();
		chat.chatType = ChatType.direct;
		chat.sourceId = userId;

		this.chatService.createChat( chat ).subscribe( createdChat => {

			this.bCreatingChat = false;

			if( createdChat ) {
				this.router.navigate( [ "/Mitgliederaustausch" ], { queryParams: { chatId: createdChat.id } } );
			}
			else {
				this.bSavingError = true;
			}
			
		});

	}

	sortData( sort: Sort ) {

		if( !sort.active || sort.direction === '' ) {
			return;
		}

		this.sortList( sort.direction, sort.active );

	}

	private sortList( direction: string, property: string ) {

		this.contactsFiltered = [ ...this.contactsFiltered ].sort( (a, b) => {

			let result = 0;
			switch( property ) {
				case 'contactName':
					const nameA = this.contactNames[ a.ebeId ];
					const nameB = this.contactNames[ b.ebeId ];
					result = nameA.localeCompare( nameB );
					break;
				case 'contactMiglied':
					break;
				default:
					break;
			}

			const isAsc = ( direction === 'asc' ) ? 1 : -1;
			return result * isAsc;

		});

	}

	private loadContactAvatars(ebeIds: (string | undefined)[]): void {
		const missing = Array.from(new Set(
			ebeIds.filter((id): id is string => !!id && !(id in this.contactAvatarUrls))
		));
		if (!missing.length) return;

		this.userProfileImageService.listMini(missing).pipe(take(1)).subscribe(result => {
			const next = { ...this.contactAvatarUrls };
			for (const id of missing) {
				next[id] = result.get(id) ?? null;
			}
			this.contactAvatarUrls = next;
		});
	}

}


